import { GlobalProperties } from '../Types/global';
import { SerializableMiniSettings } from '../Types/admin/miniSettings';
import { FrontEndModuleSettingsGroup } from '../Types/admin/eventSettings';

declare global {
	interface Window extends GlobalProperties {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		portalSettings: any;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		ExcalidrawLib: any;
		savedMiniSettings?: Partial<SerializableMiniSettings>;
		moduleSettings?: FrontEndModuleSettingsGroup[];
		portalTheme?: {
			SystemName: string;
			PrimaryColor: string;
			PrimaryTextColor: string;
			SecondaryColor: string;
			SecondaryTextColor: string;
			TextColor: string;
			PrimaryAccentColor: string;
			PrimaryAccentTextColor: string;
		};
	}
}

//TODO: Check if this really works in new react frontend, because it refuses to work in old admin
export const globalProperties: GlobalProperties = {
	...window,
};
